import * as React from 'react';

import { MAX_PROMOS_PER_SCREEN } from './constants';
import { getDescription } from './utils';
import { IPromo } from '../../types/promosPage';
import { PromoItem } from '../PromoItem';
import { CoPromoBottomContent } from '../PromoItem/parts';
import { RoundArrowLeft } from '../RoundArrowLeft';
import { RoundArrowRight } from '../RoundArrowRight';
import { Section } from '../Section';
import { VerticalSlider } from '../VerticalSlider';

interface ICoPromosProps {
  onPromoClick(promo: IPromo): void;
  title: string;
  promoList: IPromo[];
}

export const CoPromos: React.FC<ICoPromosProps> = ({ onPromoClick, promoList, title }) => {
  const itemsPerDesktopScreen = Math.min(MAX_PROMOS_PER_SCREEN, promoList.length);
  const stretchTopContent = promoList.length >= MAX_PROMOS_PER_SCREEN;

  return (
    <Section title={title} data-testid="CoPromos">
      <VerticalSlider
        rightArrow={RoundArrowRight}
        leftArrow={RoundArrowLeft}
        itemGap="16px"
        itemsPerDesktopScreen={itemsPerDesktopScreen}
      >
        {promoList.map(promo => (
          <PromoItem
            key={promo.uniqueId}
            promo={promo}
            isCoPromo
            stretchTopContent={stretchTopContent}
            bottomContent={
              <CoPromoBottomContent
                promoProp={promo.promoProps[0]}
                description={getDescription(promo, promoList.length)}
              />
            }
            onClick={() => onPromoClick(promo)}
          />
        ))}
      </VerticalSlider>
    </Section>
  );
};
